import { http } from '@/shared/api/axios';
import type {
  RequiredCredential,
  CreateRequiredCredentialRequest,
  UpdateRequiredCredentialRequest,
  AppliesToEmployeeType,
} from '../model/types';

export const requiredCredentialApi = {
  list: async (appliesTo?: AppliesToEmployeeType): Promise<RequiredCredential[]> => {
    const { data } = await http.get<RequiredCredential[]>('/v1/required-credentials', {
      params: appliesTo ? { appliesTo } : undefined,
    });
    return data;
  },
  create: async (req: CreateRequiredCredentialRequest): Promise<RequiredCredential> => {
    const { data } = await http.post<RequiredCredential>('/v1/required-credentials', req);
    return data;
  },
  update: async (
    id: number,
    req: UpdateRequiredCredentialRequest
  ): Promise<RequiredCredential> => {
    const { data } = await http.put<RequiredCredential>(`/v1/required-credentials/${id}`, req);
    return data;
  },
  delete: async (id: number): Promise<void> => {
    await http.delete(`/v1/required-credentials/${id}`);
  },
};
